import { render } from "./managementDashboard.vue?vue&type=template&id=f2dee912&scoped=true"
import script from "./managementDashboard.vue?vue&type=script&lang=js"
export * from "./managementDashboard.vue?vue&type=script&lang=js"

import "./managementDashboard.vue?vue&type=style&index=0&id=f2dee912&media=screen&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2dee912"]])

export default __exports__